module.exports = __webpack_public_path__ + "img/kran_blue.b8846ae0.svg";